import { render } from "./CandleCountDown.vue?vue&type=template&id=68828264&scoped=true&lang=html"
import script from "./CandleCountDown.vue?vue&type=script&lang=js"
export * from "./CandleCountDown.vue?vue&type=script&lang=js"

import "./CandleCountDown.vue?vue&type=style&index=0&id=68828264&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/frauenkirche/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68828264"]])

export default __exports__